import { Icon } from "@/components/Icon";
import { OrderType } from "@/constants";
import { Order } from "@/types/Api/Market/Order/myOrderDetail";
import { PendingOrder } from "@/types/Api/Market/PendingOrder/myPendingOrderDetail";
import { amountFormat } from "@/utils/tool";
import { orderStatusMap } from "./status";
export type FuncAction = {
  action: string;
  text: string;
  icon: string;
  to?: string;
  replace?: boolean;
};
export const exchangeActions: FuncAction[] = [{
  action: "exchange",
  text: "转账",
  icon: "exchange-white",
  to: "/user_transfer"
}, {
  action: "sell",
  text: "卖币",
  icon: "sell-white",
  to: "/sell"
}, {
  action: "buy",
  text: "买币",
  icon: "buy-white",
  to: "/root/trade",
  replace: true
}, {
  action: "usdt",
  text: "USDT闪兑",
  icon: "change-usdt-white",
  to: "/root/crypto_trading?type=2",
  replace: true
}];
export const funcActions: FuncAction[] = [{
  action: "scan",
  text: "扫一扫",
  icon: "scan-green"
}, {
  action: "payment",
  text: "收付款管理",
  icon: "balance-blue"
}, {
  action: "help",
  text: "帮助",
  icon: "help-orange"
}, {
  action: "custrom",
  text: "客服",
  icon: "customer-red"
}];
export enum PendingOrderStatus {
  INTRANSACTION = 1,
  HANGING = 2,
  CANCELED_SELLING = 3,
  SALE_OUT = 4,
  FROZEN = 5,
}
export const statusColor: Record<string, string> = {
  [`${PendingOrderStatus.INTRANSACTION}`]: "orange",
  [`${PendingOrderStatus.HANGING}`]: "blue",
  [`${PendingOrderStatus.CANCELED_SELLING}`]: "green",
  [`${PendingOrderStatus.SALE_OUT}`]: "red",
  [`${PendingOrderStatus.FROZEN}`]: "red",
  "": "grey"
};
export const statusText: Record<string, string> = {
  [`${PendingOrderStatus.INTRANSACTION}`]: "已发起",
  [`${PendingOrderStatus.HANGING}`]: "挂单中",
  [`${PendingOrderStatus.CANCELED_SELLING}`]: "已取消",
  [`${PendingOrderStatus.SALE_OUT}`]: "已售罄",
  [`${PendingOrderStatus.FROZEN}`]: "已冻结"
};
export const operateTypeColor: Record<string, string> = {
  [`${OrderType.INSEPARABLY}`]: "red",
  [`${OrderType.SEPARABLY}`]: "green"
};
export const operateType: Record<string, string> = {
  [`${OrderType.INSEPARABLY}`]: "不可",
  [`${OrderType.SEPARABLY}`]: "可"
};
export const orderType: Record<string, string> = {
  "1": "买",
  "2": "卖"
};
export const renderStatus = (text: any, row: any) => {
  let key = "0";
  if (row.frozen === 1) {
    key = `${PendingOrderStatus.FROZEN}`;
  } else if (row.underwayOrder > 0) key = `${PendingOrderStatus.INTRANSACTION}`;else if (row.status === 1) key = `${PendingOrderStatus.HANGING}`;
  if (row.status === 0) {
    if (row.amount === row.soldAmount) {
      key = `${PendingOrderStatus.SALE_OUT}`;
    } else {
      key = `${PendingOrderStatus.CANCELED_SELLING}`;
    }
  }
  return <span style={{
    color: statusColor[key] || "gray"
  }} data-sentry-component="renderStatus" data-sentry-source-file="key.tsx">
      {statusText[key] || key || "-"}
    </span>;
};
export const renderVol = (text: number, row: any) => <span style={{
  fontWeight: "bold",
  fontSize: "013px"
}} data-sentry-component="renderVol" data-sentry-source-file="key.tsx">
    {amountFormat(text, {
    places: 2
  })}
  </span>;
export const renderOperateType = (text: any, row: PendingOrder, subfix?: string) => {
  return <span style={{
    color: operateTypeColor[`${row.isSplit}`] || "gray"
  }} data-sentry-component="renderOperateType" data-sentry-source-file="key.tsx">
      {operateType[`${row.isSplit}`] ? `${operateType[`${row.isSplit}`]}${subfix || ""}` : text || "-"}
    </span>;
};
export const renderOrderType = (text: any, row: any) => <span style={{
  color: operateTypeColor[`${text}`] || "gray"
}} data-sentry-component="renderOrderType" data-sentry-source-file="key.tsx">
    {orderType[text] || text || "-"}
  </span>;
export const renderOperate = (text: any, row: any) => <Icon name={"operate_arrow_right"} size={"12px"} data-sentry-element="Icon" data-sentry-component="renderOperate" data-sentry-source-file="key.tsx" />;
export const renderTime = (text: any, row: any) => <>
    {text.split(' ').map((str: string) => <div key={str}>{str}</div>)}
  </>;
export const renderBusiness = (text: any, row: any) => row.isBusiness ? <span style={{
  color: "#fff",
  padding: "6px 2px",
  marginLeft: "4px",
  writingMode: "vertical-rl",
  background: text === 2 ? "#FF7D45" : "#01B14E"
}}>
    {text === 2 ? "超级" : "普通"}
  </span> : null;
export const myOrdersColumns = [{
  title: "",
  dataIndex: "isBusiness",
  span: 1,
  render: renderBusiness
}, {
  title: "挂单时间",
  dataIndex: "createTime",
  span: 7,
  render: renderTime
}, {
  title: "拆分",
  dataIndex: "isSplit",
  span: 2,
  render: (text: any, row: PendingOrder) => renderOperateType(text, row)
}, {
  title: <span>
        交易金额 <span style={{
      color: "#01B14E"
    }}>V币</span>
      </span>,
  dataIndex: "validAmount",
  span: 7,
  render: renderVol
}, {
  title: "状态",
  dataIndex: "status",
  span: 5,
  render: renderStatus
}, {
  title: "",
  dataIndex: "action",
  span: 1,
  render: renderOperate
}];
export const isSale = (row: Order, data: any) => {
  if (!data.userInfo) return false;
  return row.sellerId === data.userInfo.userId;
};
export const renderOrderStatus = (text: any, row: any) => {
  const status = orderStatusMap[text || "WaitingSellerConfirm"];
  console.log(row);
  return <>
      <span style={{
      color: status.color || "gray"
    }}>{status.text || "-"}</span>
      {row.appeal > 0 || text === 'BuyerAppeals' ? <div style={{
      color: "red",
      fontSize: '12px',
      marginTop: '2px'
    }}>争议订单</div> : null}
    </>;
};
export const renderOrderDirectStatus = (text: any, row: Order, restData: any) => {
  const sale = isSale(row, restData);
  return <span style={{
    color: sale ? "#F0535F" : "#07CA5E"
  }} data-sentry-component="renderOrderDirectStatus" data-sentry-source-file="key.tsx">
      {sale ? "卖" : "买"}
    </span>;
};
export const myTradesColumns = [{
  title: "挂单时间",
  dataIndex: "createTime",
  span: 8,
  render: renderTime
}, {
  title: "买/卖",
  dataIndex: "paymentType",
  span: 2,
  render: (text: any, row: Order, restData: any) => renderOrderDirectStatus(text, row, restData)
}, {
  title: <span>
        交易金额 <span style={{
      color: "#01B14E"
    }}>V币</span>
      </span>,
  dataIndex: "amount",
  span: 7,
  render: renderVol
}, {
  title: "状态",
  dataIndex: "status",
  span: 6,
  render: renderOrderStatus
}, {
  title: "",
  dataIndex: "action",
  span: 1,
  render: renderOperate
}];
export enum ErType {
  Member = "Member",
  Business = 'Business',
  Merchant = 'Merchant',
}
export enum SellerType {
  Member = "Member",
  Merchant = "Merchant",
  System = "System",
  Bussiness = "Bussiness",
}